import { useAppSelector } from "../../redux/configureStore";
import {
  getConversation,
  getConversationMessages,
  getConversationQuestions,
} from "./selectors";
import { useSession, useVenue } from "../api/helpers";

export const useCurrentChatTopic = () => {
  const session = useSession();
  const venue = useVenue();

  return session?.chatTopic ?? venue?.chatTopic ?? "";
};

export const useCurrentConversation = () => {
  const topic = useCurrentChatTopic();

  return useAppSelector(getConversation(topic));
};

export const useCurrentConversationMessages = () => {
  const topic = useCurrentChatTopic();

  return useAppSelector(getConversationMessages(topic));
};

export const useCurrentConversationQuestions = () => {
  const topic = useCurrentChatTopic();

  return useAppSelector(getConversationQuestions(topic));
};
